class Video extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.dataset.config);

    this.loop = this.config.loop ?? true;
    this.muted = this.config.muted ?? true;
    this.autoplay = this.config.autoplay ?? false;

    this.wrapper = this.closest(this.config.wrapper);

    this.video = this.querySelector(this.config.video);
    this.pause = this.querySelector(this.config.pause);
    this.trigger = this.querySelector(this.config.trigger);
    this.soundOn = this.querySelector(this.config.soundOn);
    this.soundOff = this.querySelector(this.config.soundOff);

    if (!this.video || !this.wrapper) return;

    this.#setListeners();
  }

  #setListeners() {
    this.trigger?.addEventListener('click', e => {
      e.preventDefault();

      this.wrapper.dataset.play = true;
      this.video.muted = this.muted;
      this.video.loop = this.loop;
      this.video.play();
    });

    this.soundOff?.addEventListener('click', e => {
      e.preventDefault();

      this.wrapper.dataset.sound = true;
      this.muted = false;
      this.video.muted = this.muted;
    });

    this.soundOn?.addEventListener('click', e => {
      e.preventDefault();

      this.wrapper.dataset.sound = false;
      this.muted = true;
      this.video.muted = this.muted;
    });

    this.video.addEventListener('click', e => {
      e.preventDefault();

      if (!this.video.paused) {
        this.wrapper.dataset.play = false;
        this.video.pause();
      } else {
        this.wrapper.dataset.play = true;
        this.video.muted = this.muted;
        this.video.play();
      }
    });

    this.pause?.addEventListener('click', e => {
      e.preventDefault();

      if (!this.video.paused) {
        this.wrapper.dataset.play = false;
        this.video.pause();
      }
    });

    if (this.autoplay) {
      isIntersecting(this.wrapper, () => {
        this.wrapper.dataset.play = true;
        this.video.loop = this.loop;
        this.video.play();
      });
    }
  }
}

customElements.define('aw-video', Video);
